module.exports = __webpack_public_path__ + "static/img/signIcon.885a2fa0.png";